/**
 * 스크롤 동작 시스템 상수
 */

// SessionStorage 키
export const SCROLL_STORAGE_KEYS = {
  PAGINATION_NAVIGATION: 'isPaginationNavigation',
  SCROLL_MEMORY: 'scroll-memory'
};

// 타이밍 상수 (밀리초)
export const SCROLL_TIMING = {
  ROUTER_DELAY: 300,        // 라우터 스크롤 동작 지연
  COMPONENT_DELAY: 100,     // 컴포넌트 레벨 작업 지연
  DEBOUNCE_MS: 150          // 스크롤 이벤트 디바운스 시간
};

// 레이아웃 상수
export const SCROLL_LAYOUT = {
  CARD_SECTION_OFFSET: 20   // 카드 섹션 상단으로부터의 오프셋 (픽셀)
};

// 성능 임계값
export const SCROLL_PERFORMANCE = {
  MAX_STORAGE_AGE: 60 * 60 * 1000  // 1시간 (밀리초)
};